import { useEffect, useState } from 'react'
import { observeNumberOfWebinarSuggestionCommentsLive } from '@domain/features/activity-comments/activity-comments-feature'

export function useWebinarSuggestionCommentsCounts(
  suggestionIds: string[],
) {
  const [counts, setCounts] = useState<Record<string, number>>({})

  useEffect(() => {
    if (suggestionIds.length === 0) {
      setCounts({})
      return () => {}
    }

    const unsubscribes = suggestionIds.map((suggestionId) =>
      observeNumberOfWebinarSuggestionCommentsLive(
        suggestionId,
        (count) => {
          setCounts((previous) => ({
            ...previous,
            [suggestionId]: count,
          }))
        },
        () => {
          setCounts((previous) => ({
            ...previous,
            [suggestionId]: previous[suggestionId] ?? 0,
          }))
        },
      ),
    )

    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe())
    }
  }, [suggestionIds.join(':')])

  return counts
}
